// extracted by mini-css-extract-plugin
export default {"progressPanel":"webpack-containers-Review-Home-StageDetail-module__progressPanel","panelSection":"webpack-containers-Review-Home-StageDetail-module__panelSection"};